export default "__VITE_ASSET__NJSUHb$f__"